import { Link, Navigate } from 'react-router'
import { AppShell } from '../../app/AppShell'
import { useLastSceneId } from '../../domains/scenes/sessionState'
import { Button, Card } from '../../design/components'
import styles from './play.module.css'

/**
 * What the Scene tab does.
 *
 * A scene belongs to a case, which belongs to a campaign, so there is no scene to show
 * until one has been picked — and unlike the Sheet and City tabs, dropping the user three
 * levels up would make the tab useless at a table.
 *
 * So the tab lands on **the scene this device last opened**. That notion is device-local
 * by nature — it is a fact about this phone at this table, not about the campaign — which
 * is exactly the kind of state Stage 7 already had to build a home for, so it costs one
 * field in `sessionState.ts` rather than a new concept.
 *
 * With no such scene, this is an empty state that points at the campaigns, rather than a
 * redirect that would bounce somebody who has never opened one.
 */
export function SceneLandingPage() {
  const lastSceneId = useLastSceneId()

  if (lastSceneId !== null) {
    return <Navigate to={`/scenes/${lastSceneId}`} replace />
  }

  return (
    <AppShell title="Scene" subtitle="NO SCENE IN PLAY">
      <Card variant="aspects" label="Nothing open">
        <p className={styles.note}>
          Open a scene from a case and this tab will come back to it. The tracker remembers the
          scene on this device only, along with its exchange counter and turn order — the API has no
          concept of either.
        </p>
      </Card>

      <Link to="/campaigns" className={styles.backLink}>
        <Button fullWidth>Pick a campaign</Button>
      </Link>
    </AppShell>
  )
}
